/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// modal

import { useTranslation } from 'react-i18next';

import {
  useCopListQuery,
  useCustomManagementQuery,
  useListCompanyMemberQuery,
  useListLevelDescriptionQuery,
  useSkillGroupListQuery,
} from 'components/company/hooks/useCompany';
import { useLocation } from 'react-router-dom';
import { tabMainGroup } from './dummySetting';
import CompetencyContent from './mainGroup/competency';
import JobDescContent from './mainGroup/jobDesc';
import MemberCompanyContent from './mainGroup/member';
import OrganizationContent from './mainGroup/organization';
import WLAContent from './mainGroup/wla';

// modal
function Settings() {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname: position } = location;
  const [tab, setTab] = useState(1);
  const dataTab = tabMainGroup({ t });

  const hidedJobLevel = position === '/board';
  // useCopListQuery(undefined, tab === 5);


  const memoComponent = useMemo(() => {
    switch (tab) {
      case 1:
        return <CompetencyContent />;
      case 2:
        return <OrganizationContent isBoardList={hidedJobLevel} />;
      case 3:
        return <WLAContent />;
      case 4:
        return <JobDescContent />;
      case 5:
        return <MemberCompanyContent />;

      default:
        return <CompetencyContent />;
    }
  }, [tab]);

  return (
    <>
      <ToastContainer />
      <div className="tab">
        <ul
          className="nav nav-tabs inner"
          role="tablist"
          style={{
            float: 'left',
            flexDirection: 'column',
          }}
        >
          {dataTab.map((val) => (
            <li key={val.value} className="nav-item">
              <a
                tabIndex={0}
                aria-disabled="true"
                className={`nav-link show title_tab ${tab === val.value ? 'active_tab' : ''}`}
                data-toggle="tab"
                role="tab"
                aria-selected="true"
                onClick={() => setTab(val.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setTab(val.value);
                  }
                }}
              >
                {val.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="tab-content !tw-py-0 tw-pl-[1.25rem] !tw-pr-0" style={{ overflow: 'hidden' }}>
          {memoComponent}
        </div>
      </div>
    </>
  );
}

export default Settings;
